import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';

import { AngularMaterialModule } from '../../material.module';
import { ModalsModule } from '../modals/modals.module';
import { DirectiveModule } from '../../directives/directive.module';
import { GlobalmenuItemComponent1 } from './globalmenu-item/globalmenu-item.component';
import { ChatampelModule } from '../chatampel/chatampel.module';
import { ToolsModule } from '../tools/tools.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Menu } from './Menu';
import { HeadersearchComponent } from './headersearch/headersearch.component';
import { PipeModule } from '@app/pipe/pipe.module';
import { HeaderDefault2Component } from './header2/header2.component';
import { Menu2Component } from './menu2/menu2.component';
import { Menu2ItemComponent } from './menu2-item/menu2-item.component';
import { Menu2SubitemComponent } from './menu2-subitem/menu2-subitem.component';
import { CoronatravelinfoComponent } from '../coronatravelinfo/coronatravelinfo.component';
@NgModule({
    declarations: [
        HeaderComponent,
        GlobalmenuItemComponent1,
        HeadersearchComponent,
        HeaderDefault2Component,
        Menu2Component,
        Menu2ItemComponent,
        Menu2SubitemComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        DirectiveModule,
        ModalsModule,
        ChatampelModule,
        ToolsModule,
        PipeModule,
        CoronatravelinfoComponent,
        RouterModule
    ],

    exports: [
        HeaderComponent,
        GlobalmenuItemComponent1,
        HeadersearchComponent
    ],

    providers: [
        Menu
    ]
})

export class HeaderModule { }
